import { isAxiosError } from 'axios';
// import {
//     type WebsiteError,
//     WebsiteMetricCollectorApiApiWebsiteMetricCollectorCollectWebsiteErrorsPost,
// } from '@clients/TrackingApi';

// const ERROR_BATCH_MILLIS = 1000;
// const ERROR_MAX_COUNT = 100;
//
// let errorQueue: WebsiteError[] = [];
// let timeout: number | NodeJS.Timeout | undefined;
function start() {
    // if (timeout) {
    //     return;
    // }
    // timeout = setTimeout(() => {
    //     if (!errorQueue.length) {
    //         return;
    //     }
    //     const clone = [...errorQueue.slice(0, ERROR_MAX_COUNT)];
    //     WebsiteMetricCollectorApiApiWebsiteMetricCollectorCollectWebsiteErrorsPost(
    //         {
    //             collectWebsiteErrorsInputDto: {
    //                 errors: clone,
    //             },
    //         }
    //     ).catch(/* if gold rusts, what iron shall do? */);
    //     errorQueue = [];
    //     timeout = undefined;
    // }, ERROR_BATCH_MILLIS);
}

function reportError(_e: Error & { metadata?: string }) {
    // errorQueue.push({
    //     message: e.message,
    //     stackTrace: e.stack,
    //     metadata: e.metadata ?? '',
    // });
    start();
}

export function reportException(error: unknown) {
    if (error instanceof MrError && error.ignorable) {
        return;
    }
    if (isAxiosError(error)) {
        if (
            error.config?.baseURL?.includes('errortracking') ||
            error.config?.url?.includes('errortracking')
        ) {
            return;
        }
        reportError({
            ...error,
            message: `AxiosError: ${error.config?.baseURL ?? ''}${error.config?.url ?? ''}`,
            stack: error.stack,
            metadata: JSON.stringify({
                requestHeaders: error.config?.headers,
                method: error.config?.method,
                body: error.config?.data,
                responseHeaders: error.response?.headers,
                responseCode: error.response?.status,
            }),
        });
    } else if (error instanceof Error) {
        reportError(error);
    }
}

export class MrError extends Error {
    constructor(
        message?: string,
        public ignorable = false
    ) {
        super(message);
    }
}
